/** @format */

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {SchoolOutlined} from '@mui/icons-material';
import {Box, List, ListItem} from '@mui/material';

import {Trans} from 'react-i18next';
import {useLocation, useNavigate} from 'react-router-dom';

import {RutubePlayer} from 'components/RutubePlayer';
import WideLayout from 'layouts/WideLayout';

import {useScrollToAnchor} from 'helpers/hooks/useScrollToAnchor';

import {useAspectRatio} from 'helpers/hooks/useAspectRatio';

import {ROUTES} from 'constants/ROUTES';

import {SECTIONS, VIDEO_ASPECT_RATIO} from './constants';
import {
  AnchorLink,
  AsideTitle,
  Content,
  Section,
  Sidebar,
  SubTitle,
  Text,
  TextAndVideoBox,
  Title,
  TwoCols,
  VideoPlayerWrap,
  BackButton,
} from './styles';

const Materials = () => {
  useScrollToAnchor();

  const {blockRef, height} = useAspectRatio(VIDEO_ASPECT_RATIO);
  const location = useLocation();
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (location.key === 'default') {
      navigate(`/${ROUTES.GROUPING}`);
    } else {
      navigate(-1);
    }
  };

  return (
    <WideLayout>
      <TwoCols>
        <Sidebar>
          <BackButton onClick={handleBackClick}>
            <ArrowBackIcon />
            <Trans>Назад</Trans>
          </BackButton>
          <Box display='flex' alignItems='center' gap={4}>
            <SchoolOutlined />
            <AsideTitle>
              <Trans>Обучающие материалы</Trans>
            </AsideTitle>
          </Box>
          <nav>
            <List disablePadding sx={{mt: 12}}>
              {SECTIONS.map(({id, index, title}) => (
                <ListItem key={id} disableGutters>
                  <AnchorLink href={`#${id}`}>
                    {index}. {title}
                  </AnchorLink>
                </ListItem>
              ))}
            </List>
          </nav>
        </Sidebar>

        <Content>
          {SECTIONS.map(({id, index, title, description, videoId}) => (
            <Section key={id} id={id}>
              <Title>{index}.</Title>
              <TextAndVideoBox>
                <Text>
                  <Title>{title}</Title>
                  {description.map((line, idx) => (
                    <SubTitle key={idx}>{line}</SubTitle>
                  ))}
                </Text>
                <VideoPlayerWrap ref={blockRef} height={height}>
                  <RutubePlayer
                    overrideWidth='100%'
                    overrideHeight={`${height}px`}
                    videoId={videoId}
                    isReplaceLink
                  />
                </VideoPlayerWrap>
              </TextAndVideoBox>
            </Section>
          ))}
        </Content>
      </TwoCols>
    </WideLayout>
  );
};

export {Materials};
